import _objectSpread from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { UPLOAD, PATCH, QUERY } from "@/core/services/store/request.module";
import { getConfig } from "@/core/services/local.service";
export default {
  name: "profile-branding-setting",
  data: function data() {
    return {
      pageLoading: true,
      items: [
      /*{
        title: "Quotation Header",
        key: "quotation_header",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
      },*/

      /*{
        title: "Quotation Footer",
        key: "quotation_footer",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },*/
      {
        title: "Invoice Header",
        key: "invoice_header",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },
      /*{
        title: "Invoice Footer",
        key: "invoice_footer",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },*/
      {
        title: "Payment Header",
        key: "payment_header",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },
      /*{
        title: "Payment Footer",
        key: "payment_footer",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },*/
      {
        title: "Visit Header",
        key: "visit_header",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      }
      /*{
        title: "Job Footer",
        key: "job_footer",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },*/

      /*{
        title: "Project Costing Header",
        key: "project_costing_header",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
      },*/

      /*{
        title: "Project Costing Footer",
        key: "project_costing_footer",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },*/

      /*{
        title: "Purchase Order Header",
        key: "purchase_header",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
      },*/

      /*{
        title: "Purchase Order Footer",
        key: "purchase_footer",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      }*/
      ],
      headerFooter: {},
      detail: {
        company_logo: null,
        facebook_url: null,
        twitter_url: null,
        instagram_url: null,
        google_plus_url: null
      },
      entityList: [],
      entity: {},
      imageRules: [function (value) {
        return !value || value.size < 2000000 || "Logo size should be less than 2 MB!";
      }]
    };
  },
  methods: {
    getBrandingSetting: function getBrandingSetting() {
      var _this = this;

      _this.detail = new Object({
        company_logo: null,
        facebook_url: null,
        twitter_url: null,
        instagram_url: null,
        google_plus_url: null
      });

      _this.$store.dispatch(QUERY, {
        url: "setting/branding",
        data: {
          entity: this.entity.id
        }
      }).then(function (_ref) {
        var data = _ref.data;
        _this.detail = data;
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    getHeaderFooterSetting: function getHeaderFooterSetting() {
      var _this = this;

      _this.headerFooter = new Object();

      _this.$store.dispatch(QUERY, {
        url: "setting/header-footer",
        data: {
          entity: this.entity.id
        }
      }).then(function (_ref2) {
        var data = _ref2.data;
        _this.headerFooter = data;
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    uploadCompanyLogo: function uploadCompanyLogo(param) {
      var _this = this;

      var formData = new FormData();
      _this.pageLoading = true;
      formData.append("files[]", param, param.name);

      _this.$store.dispatch(UPLOAD, {
        url: "file-manager/upload",
        data: formData
      }).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
          var data, i;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  data = _ref3.data;
                  i = data.length - 1;

                case 2:
                  if (!(i >= 0)) {
                    _context.next = 8;
                    break;
                  }

                  _this.detail.company_logo = data[i].file.url;
                  return _context.abrupt("break", 8);

                case 5:
                  i--;
                  _context.next = 2;
                  break;

                case 8:
                  _context.next = 10;
                  return _this.updateCompanyLogo();

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    uploadHeader: function uploadHeader(param, key) {
      var _this = this;

      var formData = new FormData();
      _this.pageLoading = true;
      formData.append("files[]", param, param.name);

      _this.$store.dispatch(UPLOAD, {
        url: "file-manager/upload",
        data: formData
      }).then( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref5) {
          var data, i;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  data = _ref5.data;
                  i = data.length - 1;

                case 2:
                  if (!(i >= 0)) {
                    _context2.next = 8;
                    break;
                  }

                  _this.detail[key] = data[i].file.url;
                  return _context2.abrupt("break", 8);

                case 5:
                  i--;
                  _context2.next = 2;
                  break;

                case 8:
                  _context2.next = 10;
                  return _this.updateCompanyHeader(key);

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    updateCompanyLogo: function updateCompanyLogo() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(PATCH, {
          url: "setting/branding",
          data: {
            company_logo: _this.detail.company_logo,
            entity: _this.entity.id
          }
        }).then(function () {
          resolve(true);
          location.reload();
        }).catch(function (error) {
          reject(error);
        }).finally(function () {
          _this.getBrandingSetting();
        });
      });
    },
    updateCompanyHeader: function updateCompanyHeader(key) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(PATCH, {
          url: "setting/header-footer",
          data: {
            image: _this.detail[key],
            key: key,
            entity: _this.entity.id
          }
        }).then(function () {
          resolve(true);
        }).catch(function (error) {
          reject(error);
        }).finally(function () {
          _this.getHeaderFooterSetting();
        });
      });
    },
    updateBrandingSetting: function updateBrandingSetting() {
      var _this = this;

      _this.pageLoading = true;

      _this.$store.dispatch(PATCH, {
        url: "setting/branding",
        data: _objectSpread(_objectSpread({}, _this.detail), {}, {
          entity: _this.entity.id
        })
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    changeImage: function changeImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    changeHeaderFooter: function changeHeaderFooter(key) {
      if (this.lodash.isEmpty(this.$refs[key]) === false && this.lodash.isEmpty(this.$refs[key][0]) === false) {
        this.$refs[key][0].$refs["input"].click();
      }
    },
    updateEntity: function updateEntity(row) {
      this.entity = row;
      this.pageLoading = true;
      this.getBrandingSetting();
      this.getHeaderFooterSetting();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      if (_this2.entity) {
        _this2.updateEntity(_this2.entity);
      }
    });
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    this.entityList = getConfig("entity");
    this.$nextTick(function () {
      _this3.entity = _this3.lodash.find(_this3.entityList, {
        id: 1
      });
    });
  }
};